import React from 'react'
import backgroundImage from '../../img/bg_image_texture4.png'
import { Link } from 'react-router-dom'
import { Card, CardContent } from '@mui/material'
import { useSelector } from 'react-redux'

const ProfileFinal = () => {
    const userData = useSelector((state) => state.userData.userData);
    return (
        <div className="vh-100 mt-5" style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <Card sx={{ maxWidth: 500, margin: 'auto' }}>
                <CardContent>
                    <div className="thankYou-modal-text">
                        <p>Thank you for registering!</p>
                    </div>
                    <div className="d-flex justify-content-start align-items-center flex-column fullPage">
                        <div className='text-center'>
                            <div className="text-center mb-4">
                                <h6 style={{color: '#A6A6A6' }}>Your account is under review.</h6>
                                <h6 style={{color: '#A6A6A6' }}>You'll be able to log in once your brand is verified by our team, which will be notified via email.</h6>
                                <h6 style={{color: '#A6A6A6' }}>This usually takes 1-2 business days.</h6>
                                <h6 style={{color: '#A6A6A6' }}>For support, contact us at info@groovenexus.com.</h6>
                            </div>
                            {userData?.avatar_url && <img src={userData?.avatar_url} alt="Img Not found" className='w-50' />}
                            {userData.authentic_brand && userData.brand && (
                            <Link to={{ pathname: "/event" }}><button className='gn-actionbtn mt-4 mb-4'>Explore Opportunities Now.</button></Link>
                            )}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default ProfileFinal;